import type { MarketGoodsListFilter } from '../pages/MarketHome/states/GoodsListFilter.atom';

export const queryKey = {
  marketDetail: (marketId: number) => ['marketDetail', marketId],
  marketParent: (marketId: number) => ['marketParent', marketId],
  marketBanner: (marketId: number) => ['marketDetail', 'banner', marketId],
  marketCoupon: (marketId: number) => ['marketDetail', 'coupon', marketId],
  mumulLiveProfileStatus: (profileSno: number) => [
    'mumulLive',
    'profileStatus',
    profileSno,
  ],
  mumulLiveCurrentCampaign: (profileSno: number) => [
    'mumulLive',
    'currentCampaign',
    profileSno,
  ],
  marketCategories: (marketId: number) => [
    'marketDetail',
    'categories',
    marketId,
  ],
  marketParentCategories: (marketId: number) => [
    'marketDetail',
    'parentCategories',
    marketId,
  ],
  marketGoodsCarousel: (marketId: number) => [
    'marketDetail',
    'carousel',
    marketId,
  ],
  marketParentGoodsCarousel: (marketId: number) => [
    'marketDetail',
    'parentCarousel',
    marketId,
  ],
  memberRequestsAvailability: (marketId: number) => [
    'marketDetail',
    'requestsAvailability',
    marketId,
  ],
  marketGoodsList: (marketId: number, params: MarketGoodsListFilter) => [
    'marketDetail',
    'goodsList',
    marketId,
    params,
  ],
  marketParentGoodsList: (marketId: number, params: MarketGoodsListFilter) => [
    'marketDetail',
    'parentGoodsList',
    marketId,
    params,
  ],
} as const;
